"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _color = _interopRequireDefault(require("../choices/color.const"));

var _size = _interopRequireDefault(require("../choices/size.const"));

var _font = _interopRequireDefault(require("../choices/font.const"));

var _timing = _interopRequireDefault(require("../choices/timing.const"));

var _spacing = _interopRequireDefault(require("../choices/spacing.const"));

var _zIndex = _interopRequireDefault(require("../choices/zIndex.const"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var dateTimeRangeSelector = {
  // <editor-fold desc="Date Time Range Selector styling">
  fontSize: _font["default"].sizeSm,
  lineHeight: _font["default"].lineHeightSm,
  fontFamily: _font["default"].family,
  // </editor-fold>
  // <editor-fold desc="Input Box styling">
  borderColor: _color["default"].cloudyBlue300,
  borderColorOpen: _color["default"].dodgerBlue,
  borderColorError: _color["default"].coral,
  borderSize: _size["default"].borderSizeDefault,
  borderRadius: 0,
  width: '380px',
  heightSmall: _size["default"].formItemSizeSmall,
  heightLarge: _size["default"].formItemSizeLarge,
  backgroundColor: _color["default"].white,
  backgroundColorDisabled: _color["default"].cloudyBlue100,
  color: _color["default"].pickledBluewood800,
  colorDisabled: _color["default"].cloudyBlue,
  placeholderColor: _color["default"].cloudyBlue,
  paddingVerticalSmall: "".concat(parseInt(_spacing["default"].xxs, 10) - parseInt(_size["default"].borderSizeDefault, 10), "px"),
  paddingVerticalLarge: "".concat(parseInt(_spacing["default"].xs, 10) - parseInt(_size["default"].borderSizeDefault, 10), "px"),
  paddingHorizontal: _spacing["default"].sm,
  iconColor: _color["default"].steel700,
  transitionTiming: _timing["default"].fast,
  iconMinSize: _size["default"].medium,
  iconTopOffset: _spacing["default"].sm,
  iconRightOffset: _spacing["default"].sm,
  // </editor-fold>
  // <editor-fold desc="Dropdown styling">
  containerZIndex: _zIndex["default"].z2000 + 500,
  containerBorderSize: _size["default"].borderSizeDefault,
  containerBorderColor: _color["default"].cloudyBlue300,
  containerShadowBlurRadius: _size["default"].small,
  containerShadowColor: _color["default"].cloudyBlue300,
  containerBackgroundColor: _color["default"].white,
  containerAnimationDuration: _timing["default"].fast,
  footerMarginSmall: _spacing["default"].xxs,
  footerMarginLarge: _spacing["default"].xs,
  footerPadding: _spacing["default"].md,
  footerBorderSize: _size["default"].borderSizeDefault,
  footerBorderColor: _color["default"].cloudyBlue300,
  calendarHorizontalMargin: _spacing["default"].lg,
  calendarBottomMargin: _spacing["default"].xxl,
  dateTimeInputsPadding: _spacing["default"].sm,
  dateTimeInputsMarginBottom: _spacing["default"].sm,
  dateTimeInputsBorderSize: _size["default"].borderSizeDefault,
  dateTimeInputsBorderColor: _color["default"].cloudyBlue300,
  dateInputMarginRight: _spacing["default"].sm,
  dateInputWidth: '102px',
  timeInputMarginRight: _spacing["default"].sm,
  timeInputWidth: '90px',
  timeInputContainerMarginLeft: _spacing["default"].md,
  endTimeErrorColor: _color["default"].coral,
  endTimeErrorLineHeight: _font["default"].lineHeightXs,
  endTimeErrorFontSize: _font["default"].sizeXs,
  // </editor-fold>
  // <editor-fold desc="Predefined List styling">
  listBackgroundColor: _color["default"].cloudyBlue100,
  listBorderRightColor: _color["default"].cloudyBlue300,
  listBorderRightSize: _size["default"].borderSizeDefault,
  listWidth: '140px',
  listItemFontSize: _font["default"].sizeXs,
  listItemLineHeight: _font["default"].lineHeightXs,
  listItemPaddingVertical: _spacing["default"].xs,
  listItemPaddingHorizontal: "".concat(parseInt(_spacing["default"].sm, 10) - 2 * parseInt(_size["default"].borderSizeDefault, 10), "px"),
  listItemHeight: '38px',
  listItemColor: _color["default"].pickledBluewood800,
  listItemSelectedColor: _color["default"].dodgerBlue,
  listItemSelectedWidth: _size["default"].small,
  listInputHeight: '32px',
  listInputMarginTop: "-".concat(parseInt(_spacing["default"].xs, 10) - parseInt(_size["default"].borderSizeDefault, 10), "px"),
  listInputMarginBottom: "-".concat(parseInt(_spacing["default"].xs, 10) - 2 * parseInt(_size["default"].borderSizeDefault, 10), "px"),
  listInputMarginLeft: _spacing["default"].xxs,
  listInputMarginRight: "".concat(parseInt(_spacing["default"].xxs, 10) - parseInt(_size["default"].borderSizeDefault, 10), "px"),
  listInputHorizontalSpacing: _spacing["default"].xxs,
  listInputMinWidth: 0,
  listInputWidth: '28px',
  listInputVerticalSpacing: 0 // </editor-fold>

};
var _default = dateTimeRangeSelector;
exports["default"] = _default;